var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved",
    transform: "translate(-1085 -3396)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1085 3396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Approved_Icon",
    "data-name": "Approved Icon",
    d: "M20,0A20,20,0,1,0,40,20,20.022,20.022,0,0,0,20,0ZM30.137,15.762,19.3,26.595a1.665,1.665,0,0,1-2.357,0L11.53,21.178a1.666,1.666,0,1,1,2.357-2.357l4.238,4.238,9.655-9.655a1.666,1.666,0,1,1,2.357,2.357Zm0,0",
    transform: "translate(1085 3396)",
    fill: "#00c851"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.439ea0146f7ba40125e23278545a2f88.svg";
export { ForwardRef as ReactComponent };